export const ANALYTICS_TYPE_REVYRE_TILES = 'revyre_tiles';
export const ANALYTICS_TYPE_REVYRE_TILE_CLICKED = 'revyre_tile_clicked';
export const ANALYTICS_TYPE_REVYRE_LIST = 'revyre_list';
export const ANALYTICS_TYPE_REVYRE_CREATE_INITIATED = 'revyre_create_initiated';
export const ANALYTICS_TYPE_REVYRE_DETAILS_OPENED = 'revyre_details_opened';
export const ANALYTICS_TYPE_REVYRE_DETAILS = 'revyre_details';
export const ANALYTICS_TYPE_REVYRE_FORM_INITIATED = 'revyre_form_initiated';
export const ANALYTICS_TYPE_REVYRE_FORM_SUBMIT = 'revyre_form_submit';
export const ANALYTICS_TYPE_REVYRE_PHONE_CALL = 'revyre_phone_call';
export const ANALYTICS_TYPE_MENU_CLICK = 'menu_click';

export const ANALYTICS_EVENT_ID_STORAGE_KEY = 'analytics_event_id';
export const ANALYTICS_SESSION_ID_STORAGE_KEY = 'analytics_session_id';
export const ANALYTICS_SESSION_TIMEOUT = 60 * 60 * 1000;
